<template>
  <div class="auth">
    <div class="auth-logo">
      <img src="@/assets/2-1.png">
    </div>
    <div class="auth-container">
      <div class="auth-wrapper">
        <p class="auth-title">Reset Password</p>
        <primary-input type="password"
                       name="password"
                       v-validate="'required'"
                       v-model="passwd"
                       :class="{'email-input': true, 'is-danger': errors.has('first name')}"
                       ref="password"
                       placeholder="********" />
        <div class="help is-danger"
             v-if="errors.has('password')">
          {{ errors.first('password') }}
        </div>
        <primary-input type="password"
                       name="re-enter password"
                       v-model="passwd2"
                       v-validate="'required|confirmed:password'"
                       data-vv-as="password"
                       :class="{'email-input': true, 'is-danger': errors.has('first name')}"
                       placeholder="********" />
        <div class="help is-danger"
             v-if="errors.has('re-enter password')">
          {{ errors.first('re-enter password') }}
        </div>
        <button @click="resetPassword"
                class="primary-button">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import('../../components/Inputs/PrimaryInput.vue')
  },
  data: () => ({
    email: '',
    error: null,
    passwd: null,
    passwd2: null
  }),
  methods: {
    resetPassword() {
      this.$validator.validate().then(result => {
        if(result) {
          this.$store.dispatch('resetConfirmation', {passwd: this.passwd, token: this.$route.params.token}).then(() => {
            this.$router.push({name: 'login'});
            this.$snotify.success("Password reseted.", {
                timeout: 6000,
            })
          }).catch(() => {
            this.$router.push({name: 'forgot-password'});
            this.$snotify.error("Password verification link has expired", {
              timeout: 6000,
            })
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .auth-logo {
    margin-top: 45px;
    margin-bottom: 75px;
  }
  .auth-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .auth-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 420px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      padding: 60px;
      .auth-title {
        color: #000000;
        font-family: ""Helvetica Neue"";
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }
      .email-input {
        margin-bottom: 20px;
      }
      button {
        align-self: flex-start;
        width: 90px;
        height: 40px;
      }
    }
  }
}
</style>

